import { getCountrySpecificRules } from '@helpers/config/countrySpecificRules';

/**
 * Determines if a country has a fiscale code field
 * @param {string} iso ISO code for country
 * @returns {boolean} True if country has fiscale code
 */
export const hasFiscaleCode = iso => getCountrySpecificRules(iso, 'registrations').hasFiscaleCode;
